/* WHERE IS UP? — Gallery theme JS (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: { root: '/' }, strings: {} };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.drawer__panel', d);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    var cartOpener = e.target.closest('[data-open-cart]');
    if (cartOpener && theme.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      e.preventDefault(); openDrawer('CartDrawer');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    var lb = $('[data-lightbox].is-open'); if (lb) lb.classList.remove('is-open');
    $$('[data-dropdown].is-open').forEach(function (li) { li.classList.remove('is-open'); var b = $('.nav__link', li); if (b) b.setAttribute('aria-expanded', 'false'); });
  });

  /* ---------- Search ---------- */
  function closeSearch() { var m = $('#SearchModal'); if (m && m.classList.contains('is-open')) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; } }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) {
      var m = $('#SearchModal'); if (!m) return;
      m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var i = $('[data-search-input]', m); if (i) i.focus(); }, 30);
    }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });

  /* ---------- Header ---------- */
  function fitHeader() {
    $$('.header').forEach(function (h) {
      var left = $('.header__left', h), nav = left && $('.header__nav', left);
      if (!nav) return;
      h.classList.remove('is-compact', 'is-shifted');
      if (window.matchMedia('(max-width: 989px)').matches) return;
      if (nav.scrollWidth <= left.clientWidth + 1) return;
      var logo = $('.header__logo', h), icons = $('.header__icons', h) || h.lastElementChild;
      var cs = getComputedStyle(h), gap = parseFloat(cs.columnGap) || 24;
      var inner = h.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var contentW = function (el) { if (!el) return 0; var r = document.createRange(); r.selectNodeContents(el); return r.getBoundingClientRect().width; };
      var room = inner - contentW(logo) - contentW(icons) - gap * 2;
      if (h.getAttribute('data-overflow') !== 'compact' && nav.scrollWidth <= room) h.classList.add('is-shifted');
      else h.classList.add('is-compact');
    });
  }

  function initHeader() {
    fitHeader();
    window.addEventListener('resize', fitHeader);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeader);
    var header = $('[data-header]');
    if (!header) return;
    var sectionEl = header.closest('.shopify-section') || header;
    var mode = header.getAttribute('data-sticky');
    var lastY = window.scrollY;
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (mode === 'scroll-up') {
        var menuOpen = !!$('[data-dropdown].is-open');
        if (y > lastY && y > 200 && !menuOpen) sectionEl.classList.add('is-hidden');
        else sectionEl.classList.remove('is-hidden');
      }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Dropdowns: click/keyboard toggle (hover handled in CSS)
    $$('[data-dropdown]', header).forEach(function (li) {
      var btn = $('.nav__link', li);
      btn.addEventListener('click', function () {
        var open = !li.classList.contains('is-open');
        $$('[data-dropdown].is-open', header).forEach(function (o) { o.classList.remove('is-open'); $('.nav__link', o).setAttribute('aria-expanded', 'false'); });
        li.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        header.classList.toggle('menu-open', open);
      });
      li.addEventListener('mouseenter', function () { btn.setAttribute('aria-expanded', 'true'); header.classList.add('menu-open'); });
      li.addEventListener('mouseleave', function () { btn.setAttribute('aria-expanded', 'false'); li.classList.remove('is-open'); header.classList.remove('menu-open'); });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dropdown]')) {
        $$('[data-dropdown].is-open', header).forEach(function (o) { o.classList.remove('is-open'); $('.nav__link', o).setAttribute('aria-expanded', 'false'); });
        header.classList.remove('menu-open');
      }
    });
  }

  /* ---------- Announcement ---------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0, interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------- Hero video ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var video = $('video', hero);
      var btn = $('[data-hero-sound]', hero);
      if (video) {
        video.muted = true;
        var p = video.play && video.play();
        if (p && p.catch) p.catch(function () {});
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { var pp = video.play(); if (pp && pp.catch) pp.catch(function () {}); } else video.pause(); });
          }, { threshold: 0.1 }).observe(hero);
        }
      }
      if (btn && video) {
        btn.addEventListener('click', function () {
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          $('[data-sound-off]', btn).hidden = !video.muted;
          $('[data-sound-on]', btn).hidden = video.muted;
        });
      }
    });
  }

  /* ---------- Reveal ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
  }
  function refreshDrawer(open) {
    var drawer = document.getElementById('CartDrawer');
    var url = (theme.routes.root || '/') + '?sections=cart-drawer';
    return fetch(url.replace('//?', '/?'), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (drawer && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = $('.drawer__panel', tmp);
          var current = $('.drawer__panel', drawer);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          bindCartItems(drawer);
          bindForms(drawer);
        }
        return fetch(theme.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (open && drawer) openDrawer('CartDrawer');
        return cart;
      });
  }
  function addToCart(form, button) {
    var fd = new FormData(form);
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (theme.cartType === 'drawer' && document.getElementById('CartDrawer')) return refreshDrawer(true);
        window.location.href = theme.routes.cart;
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); } });
  }
  function bindForms(ctx) {
    $$('form.js-product-form', ctx).forEach(function (form) {
      if (form._bound) return; form._bound = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = e.submitter || $('[type="submit"]', form);
        if (btn && btn.disabled) return;
        addToCart(form, btn);
      });
    });
  }
  function changeLine(line, qty, ctx) {
    ctx && ctx.classList && ctx.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        return refreshDrawer(false);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not update cart'); refreshDrawer(false); });
  }
  function bindCartItems(ctx) {
    $$('.cart-item', ctx).forEach(function (row) {
      if (row._bound) return; row._bound = true;
      var line = parseInt(row.getAttribute('data-line'), 10);
      var input = $('[data-qty-input]', row);
      $$('[data-qty-change]', row).forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(0, parseInt(input.value, 10) + parseInt(b.getAttribute('data-qty-change'), 10));
          input.value = next; changeLine(line, next, row);
        });
      });
      if (input) input.addEventListener('change', function () { changeLine(line, Math.max(0, parseInt(input.value, 10) || 0), row); });
      var rm = $('[data-remove]', row);
      if (rm) rm.addEventListener('click', function () { changeLine(line, 0, row); });
    });
  }

  /* ---------- Product ---------- */
  function initProduct() {
    $$('[data-product-section]').forEach(function (section) {
      var jsonEl = $('[data-product-json]', section.parentNode) || $('[data-product-json]');
      if (!jsonEl) return;
      var data; try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var form = $('form.js-product-form[id^="ProductForm"]', section);
      var idInput = form && $('[data-variant-id]', form);
      var addBtn = form && $('[data-add-button]', form);
      var addText = addBtn && $('[data-add-text]', addBtn);
      var defaultAddText = addText ? addText.textContent.trim() : 'Add to cart';
      if (addBtn && addBtn.disabled) defaultAddText = data.oneOfOne ? 'Collect this piece' : (theme.strings.addToCart || 'Add to cart');
      var stickyBtn = $('[data-sticky-add]');
      var stickyPrice = $('[data-sticky-price]');
      var stockWrap = $('[data-stock]', section);
      var stockText = stockWrap && $('[data-stock-text]', stockWrap);
      var stockTemplate = null;

      function selectedOptions() {
        var opts = [];
        $$('[data-variant-picker] fieldset', section).forEach(function (fs, i) {
          var checked = $('input:checked', fs);
          opts[i] = checked ? checked.value : null;
        });
        return opts;
      }
      function findVariant(opts) {
        return data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === null || o === opts[i]; });
        })[0];
      }
      function markAvailability(opts) {
        $$('[data-variant-picker] fieldset', section).forEach(function (fs, i) {
          $$('input', fs).forEach(function (inp) {
            var test = opts.slice(); test[i] = inp.value;
            var any = data.variants.some(function (v) { return v.available && v.options.every(function (o, j) { return test[j] == null || o === test[j]; }); });
            inp.classList.toggle('is-unavailable', !any);
          });
        });
      }
      function update() {
        var opts = selectedOptions();
        markAvailability(opts);
        opts.forEach(function (val, i) { var label = $('[data-option-value="' + i + '"]', section); if (label) label.textContent = val; });
        var v = findVariant(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addText.textContent = theme.strings.unavailable || 'Unavailable'; }
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = theme.strings.unavailable || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        $$('form[id="ProductInstallments"] input[name="id"]').forEach(function (i) { i.value = v.id; });
        var priceWrap = $('[data-price-wrap] [data-price]', section);
        if (priceWrap) {
          var sale = v.compare_at_price > v.price;
          priceWrap.classList.toggle('price--sale', sale);
          priceWrap.innerHTML = '<span class="price__current">' + v.price_formatted + '</span>' + (sale ? '<span class="price__compare">' + v.compare_formatted + '</span>' : '');
        }
        if (stickyPrice) stickyPrice.textContent = v.price_formatted;
        var soldText = theme.strings.soldOut || 'Sold out';
        if (addBtn) { addBtn.disabled = !v.available; addText.textContent = v.available ? defaultAddText : soldText; }
        if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? (theme.strings.addToCart || 'Add to cart') : soldText; }
        if (stockText) {
          if (stockTemplate === null) stockTemplate = { cls: stockText.className, txt: stockText.textContent };
          var threshold = parseInt(stockWrap.getAttribute('data-threshold'), 10) || 5;
          if (!v.available) { stockText.className = 'stock stock--out'; stockText.textContent = soldText; }
          else if (!data.oneOfOne && v.inventory !== null && v.inventory > 0 && v.inventory <= threshold) { stockText.className = 'stock stock--low'; stockText.textContent = 'Only ' + v.inventory + ' left'; }
          else if (data.oneOfOne) { stockText.className = 'stock stock--low'; }
          else { stockText.className = 'stock'; if (/left|sold|collected/i.test(stockText.textContent)) stockText.textContent = 'In stock · ready to ship'; }
        }
        if (v.media_id) {
          var media = $('[data-media-id="' + v.media_id + '"]', section);
          var gallery = $('[data-gallery]', section);
          if (media && gallery) {
            if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
            else if (gallery.firstElementChild !== media) gallery.insertBefore(media, gallery.firstElementChild);
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      $$('[data-variant-picker] input', section).forEach(function (inp) { inp.addEventListener('change', update); });
      if ($('[data-variant-picker]', section)) markAvailability(selectedOptions());

      // Quantity
      $$('[data-qty-step]', section).forEach(function (b) {
        b.addEventListener('click', function () {
          var inp = $('input[name="quantity"]', section);
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        });
      });

      // Mobile gallery dots
      var gallery = $('[data-gallery]', section);
      var dots = $$('.gallery-dots span', section);
      if (gallery && dots.length) {
        gallery.addEventListener('scroll', function () {
          var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }, { passive: true });
      }

      // Lightbox
      var lb = $('[data-lightbox]');
      if (lb) {
        $$('[data-zoom]', section).forEach(function (item) {
          item.addEventListener('click', function () {
            if (window.matchMedia('(max-width: 989px)').matches && gallery.scrollWidth > gallery.clientWidth + 5) { /* allow swipe; still open on tap */ }
            var content = $('[data-lightbox-content]', lb);
            content.innerHTML = '';
            $$('[data-zoom]', section).forEach(function (z) {
              var img = document.createElement('img'); img.src = z.getAttribute('data-zoom'); img.alt = ''; img.loading = 'lazy';
              content.appendChild(img);
              if (z === item) setTimeout(function () { img.scrollIntoView(); }, 30);
            });
            lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
          });
        });
        $('[data-lightbox-close]', lb).addEventListener('click', function () { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; });
      }

      // Sticky add to cart
      var sticky = $('[data-sticky-atc]');
      if (sticky && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var show = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }).observe(form);
      }
    });

    // Copy link
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-copy-link]'); if (!b) return;
      if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy-link')).then(function () { toast('Link copied'); });
    });
  }

  /* ---------- Collection ---------- */
  function initCollection() {
    $$('[data-autosubmit]').forEach(function (sel) { sel.addEventListener('change', function () { sel.form.submit(); }); });
    $$('[data-filter-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var params = new URLSearchParams();
        new FormData(form).forEach(function (val, key) { if (val !== '') params.append(key, val); });
        window.location.search = params.toString();
      });
      $$('input[type="checkbox"]', form).forEach(function (cb) {
        cb.addEventListener('change', function () { if (window.matchMedia('(min-width: 990px)').matches) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit')); });
      });
    });
  }

  /* ---------- Chip groups (multi/single select → one hidden field) ---------- */
  function initChips(ctx) {
    $$('[data-chip-group]', ctx).forEach(function (group) {
      if (group._bound) return; group._bound = true;
      var multiple = group.getAttribute('data-multiple') === 'true';
      var hidden = $('[data-chip-value]', group);
      var other = $('[data-chip-other]', group);
      function sync() {
        var vals = $$('.chip[aria-pressed="true"]', group).map(function (c) { return c.getAttribute('data-value'); });
        hidden.value = vals.join(', ');
        var otherOn = vals.indexOf('Other') !== -1;
        if (other) { other.hidden = !otherOn; if (otherOn) other.focus(); }
        if (vals.length) { group.classList.remove('has-error'); var er = $('.field__error', group); if (er) er.hidden = true; }
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
      $$('.chip', group).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var on = chip.getAttribute('aria-pressed') !== 'true';
          if (!multiple) $$('.chip', group).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          chip.setAttribute('aria-pressed', on ? 'true' : 'false');
          sync();
        });
      });
    });
  }

  /* ---------- Smart form validation (commission, applications, bids) ---------- */
  function fieldVisible(el) { return !el.disabled && !el.closest('[hidden]'); }
  function validateForm(form) {
    var firstBad = null;
    function mark(container, bad) {
      if (!container) return;
      container.classList.toggle('has-error', bad);
      var er = $('.field__error', container); if (er) er.hidden = !bad;
      if (bad && !firstBad) firstBad = container;
    }
    $$('[data-chip-group][data-required]', form).forEach(function (g) {
      if (g.closest('[hidden]')) return;
      mark(g, !$('[data-chip-value]', g).value);
    });
    $$('input[required], select[required], textarea[required]', form).forEach(function (el) {
      if (!fieldVisible(el)) return;
      var bad = el.type === 'checkbox' ? !el.checked : !el.value.trim() || (el.type === 'email' && !/^\S+@\S+\.\S+$/.test(el.value));
      if (el.type === 'number' && !bad && el.min !== '' && parseFloat(el.value) < parseFloat(el.min)) bad = true;
      var c = el.closest('.field') || el.closest('label') || el.parentNode;
      mark(c, bad);
      if (el.type === 'checkbox') { var ae = $('[data-agree-error]', form); if (ae) ae.hidden = !bad; if (bad && !firstBad) firstBad = el; }
    });
    var anyGroups = {};
    $$('[data-required-any]', form).forEach(function (el) { if (fieldVisible(el)) (anyGroups[el.getAttribute('data-required-any')] = anyGroups[el.getAttribute('data-required-any')] || []).push(el); });
    Object.keys(anyGroups).forEach(function (k) {
      var ok = anyGroups[k].some(function (el) { return el.type === 'checkbox' ? el.checked : el.value.trim(); });
      var er = $('[data-any-error="' + k + '"]', form); if (er) er.hidden = ok;
      if (!ok && !firstBad) firstBad = er;
    });
    if (firstBad) { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return false; }
    return true;
  }
  function initSmartForms() {
    $$('.commission-form, .auction-form, .smart-form').forEach(function (form) {
      if (form._smart) return; form._smart = true;
      form.addEventListener('submit', function (e) { if (!validateForm(form)) e.preventDefault(); });
    });
  }

  /* ---------- Commission branching ---------- */
  /* Secret arcade: tap the footer eye 3 times, or type "up?" anywhere. Loads only when found. */
  function initArcade() {
    if (!theme.arcade) return;
    var loading = false;
    function launch() {
      if (window.WIUArcade) { window.WIUArcade.open(); return; }
      if (loading) return; loading = true;
      var sc = document.createElement('script'); sc.src = theme.arcade; sc.async = true;
      sc.onload = function () { loading = false; if (window.WIUArcade) window.WIUArcade.open(); };
      sc.onerror = function () { loading = false; };
      document.head.appendChild(sc);
    }
    var taps = 0, timer = null;
    $$('[data-arcade-trigger]').forEach(function (el) {
      el.addEventListener('click', function () {
        taps++; clearTimeout(timer); timer = setTimeout(function () { taps = 0; }, 1200);
        el.classList.remove('is-blink'); void el.offsetWidth; el.classList.add('is-blink');
        if (taps >= 3) { taps = 0; launch(); }
      });
    });
    var seq = '';
    document.addEventListener('keydown', function (e) {
      var tg = e.target; if (tg && (tg.isContentEditable || /INPUT|TEXTAREA|SELECT/.test(tg.tagName))) return;
      if (!e.key || e.key.length !== 1) return;
      seq = (seq + e.key.toLowerCase()).slice(-3);
      if (seq === 'up?') { seq = ''; launch(); }
    });
  }

  function initInterestTags(ctx) {
    $$('[data-interest-tags]', ctx || document).forEach(function (box) {
      var form = box.closest('form'); if (!form) return;
      var field = $('[data-base-tags]', form); if (!field) return;
      var sync = function () {
        var tags = (field.getAttribute('data-base-tags') || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        $$('input[type=checkbox]:checked', box).forEach(function (c) { tags.push(c.value); });
        field.value = tags.join(', ');
      };
      box.addEventListener('change', sync); form.addEventListener('submit', sync); sync();
    });
  }

  /* Commissions: picking "Luxury / designer" removes budgets that can't cover a designer garment. */
  function initLuxuryBudget(ctx) {
    $$('[data-luxury-budget]', ctx || document).forEach(function (sel) {
      var form = sel.closest('form'); if (!form) return;
      var style = form.querySelector('[name="contact[Garment style]"]'); if (!style) return;
      var hide = (sel.getAttribute('data-luxury-hide') || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
      var note = $('[data-luxury-note]', form);
      var sync = function () {
        var lux = /luxury|designer/i.test(style.value);
        $$('option', sel).forEach(function (o) {
          var off = lux && hide.indexOf(o.textContent.trim()) !== -1;
          o.hidden = off; o.disabled = off;
          if (off && o.selected) sel.value = '';
        });
        if (note) note.hidden = !lux;
      };
      style.addEventListener('change', sync); sync();
    });
  }

  /* Instagram feed: fills the grid from a Behold JSON feed when one is linked. */
  function initInstagram(ctx) {
    $$('[data-ig-feed]', ctx || document).forEach(function (sec) {
      if (sec._ig) return; sec._ig = true;
      var url = sec.getAttribute('data-ig-feed'), n = +sec.getAttribute('data-ig-count') || 6;
      var grid = $('[data-ig-grid]', sec), stats = $('[data-ig-stats]', sec), av = $('[data-ig-avatar]', sec);
      var fmt = function (v) { return v >= 1e6 ? (v / 1e6).toFixed(1).replace(/\.0$/, '') + 'M' : v >= 1e4 ? (v / 1e3).toFixed(1).replace(/\.0$/, '') + 'K' : String(v); };
      fetch(url).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
        var posts = (d.posts || []).slice(0, n);
        if (stats && d.followersCount != null) stats.textContent = fmt(d.followersCount) + ' followers';
        if (av && d.profilePictureUrl) { av.innerHTML = ''; var im = new Image(); im.src = d.profilePictureUrl; im.alt = ''; im.loading = 'lazy'; av.appendChild(im); }
        if (!posts.length || !grid) return;
        grid.innerHTML = '';
        posts.forEach(function (p) {
          var src = (p.sizes && p.sizes.medium && p.sizes.medium.mediaUrl) || p.thumbnailUrl || p.mediaUrl;
          if (!src) return;
          var li = document.createElement('li'), a = document.createElement('a'), im = new Image();
          a.href = p.permalink; a.target = '_blank'; a.rel = 'noopener'; a.className = 'ig__post';
          im.src = src; im.loading = 'lazy'; im.alt = p.altText || p.prunedCaption || 'Instagram post';
          a.appendChild(im);
          if (p.mediaType === 'VIDEO') { var b = document.createElement('span'); b.className = 'ig__badge'; b.textContent = 'Video'; a.appendChild(b); }
          li.appendChild(a); grid.appendChild(li);
        });
      }).catch(function () { /* keep the posts added by hand */ });
    });
  }

  /* Music player: studio audio files play here; Spotify links load Spotify's small official player. */
  function initPlayers(ctx) {
    $$('[data-player]', ctx || document).forEach(function (box) {
      if (box._player) return; box._player = true;
      var audio = $('[data-audio]', box), ui = $('[data-audio-ui]', box), host = $('[data-spotify-host]', box);
      var btn = $('[data-toggle]', box), seek = $('[data-seek]', box), tEl = $('[data-time]', box), dEl = $('[data-dur]', box), title = $('[data-now-title]', box);
      var tracks = $$('[data-track]', box), current = null, sp = null, spReady = null;
      var mmss = function (x) { x = Math.max(0, Math.floor(x || 0)); return Math.floor(x / 60) + ':' + ('0' + (x % 60)).slice(-2); };
      var mark = function (el) { tracks.forEach(function (t) { t.classList.toggle('is-current', t === el); t.setAttribute('aria-pressed', t === el ? 'true' : 'false'); }); };
      var setPlaying = function (on) { box.classList.toggle('is-playing', on); if (btn) btn.setAttribute('aria-label', on ? 'Pause' : 'Play'); };
      function spotifyUri(u) {
        var m = String(u).match(/open\.spotify\.com\/(?:intl-[a-z]+\/)?(track|album|playlist|artist|episode|show)\/([A-Za-z0-9]+)/);
        return m ? 'spotify:' + m[1] + ':' + m[2] : u;
      }
      function loadSpotifyApi() {
        if (spReady) return spReady;
        spReady = new Promise(function (resolve) {
          if (window.__wiuSpotifyApi) return resolve(window.__wiuSpotifyApi);
          var prev = window.onSpotifyIframeApiReady;
          window.onSpotifyIframeApiReady = function (api) { window.__wiuSpotifyApi = api; if (prev) prev(api); resolve(api); };
          var sc = document.createElement('script'); sc.src = 'https://open.spotify.com/embed/iframe-api/v1'; sc.async = true; document.head.appendChild(sc);
        });
        return spReady;
      }
      function playSpotify(el) {
        audio.pause(); ui.hidden = true; host.hidden = false;
        var uri = spotifyUri(el.getAttribute('data-src')), tall = el.hasAttribute('data-tall');
        loadSpotifyApi().then(function (api) {
          if (sp) { sp.loadUri(uri); sp.play(); return; }
          var mount = document.createElement('div'); host.innerHTML = ''; host.appendChild(mount);
          api.createController(mount, { uri: uri, width: '100%', height: tall ? 352 : 152 }, function (c) {
            sp = c; c.addListener('ready', function () { c.play(); });
          });
        });
      }
      function playAudio(el) {
        if (sp) sp.pause();
        host.hidden = true; ui.hidden = false;
        if (audio.getAttribute('src') !== el.getAttribute('data-src')) { audio.src = el.getAttribute('data-src'); seek.value = 0; }
        var p = audio.play(); if (p && p.catch) p.catch(function () { setPlaying(false); });
      }
      tracks.forEach(function (el) {
        el.setAttribute('aria-pressed', 'false');
        el.addEventListener('click', function () {
          if (current === el && el.getAttribute('data-kind') === 'audio') { audio.paused ? audio.play() : audio.pause(); return; }
          current = el; mark(el); if (title) title.textContent = el.getAttribute('data-title');
          el.getAttribute('data-kind') === 'spotify' ? playSpotify(el) : playAudio(el);
        });
      });
      if (btn) btn.addEventListener('click', function () { if (!current) { if (tracks[0]) tracks[0].click(); return; } audio.paused ? audio.play() : audio.pause(); });
      audio.addEventListener('play', function () { setPlaying(true); });
      audio.addEventListener('pause', function () { setPlaying(false); });
      audio.addEventListener('loadedmetadata', function () { dEl.textContent = mmss(audio.duration); });
      audio.addEventListener('timeupdate', function () { tEl.textContent = mmss(audio.currentTime); if (audio.duration) seek.value = Math.round(audio.currentTime / audio.duration * 1000); });
      audio.addEventListener('ended', function () {
        var i = tracks.indexOf(current), next = tracks[i + 1];
        if (next && next.getAttribute('data-kind') === 'audio') next.click(); else setPlaying(false);
      });
      seek.addEventListener('input', function () { if (audio.duration) audio.currentTime = seek.value / 1000 * audio.duration; });
    });
  }

  function initNoRush(ctx) {
    $$('[data-no-rush]', ctx || document).forEach(function (box) {
      var form = box.closest('form'); if (!form) return;
      var target = $('[data-no-rush-target]', form); if (!target) return;
      var sync = function () { target.disabled = box.checked; if (box.checked) target.value = ''; };
      box.addEventListener('change', sync); sync();
    });
  }

  function initCommission() {
    $$('.commission-form').forEach(function (form) {
      var cards = $$('.path-card', form);
      if (!cards.length) return;
      var pathInput = $('[data-path-value]', form);
      function setPath(path) {
        cards.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-path') === path ? 'true' : 'false'); });
        $$('[data-panel]', form).forEach(function (p) {
          var name = p.getAttribute('data-panel');
          var show = name === 'shared' ? !!path : name === path;
          p.hidden = !show;
          $$('input, select, textarea', p).forEach(function (el) { el.disabled = !show; });
        });
        pathInput.value = path === 'own' ? 'Yes — sending my own garment' : 'No — please source it';
        var pe = $('[data-path-error]', form); if (pe) pe.hidden = true;
      }
      $$('[data-panel] input, [data-panel] select, [data-panel] textarea', form).forEach(function (el) { el.disabled = true; });
      cards.forEach(function (c) {
        c.addEventListener('click', function () {
          setPath(c.getAttribute('data-path'));
          var panel = $('[data-panel="' + c.getAttribute('data-path') + '"]', form);
          if (panel) setTimeout(function () { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
        });
      });
      form.addEventListener('submit', function (e) {
        if (!pathInput.value) { e.preventDefault(); var pe = $('[data-path-error]', form); if (pe) { pe.hidden = false; pe.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
      }, true);
      var params = new URLSearchParams(window.location.search);
      var insp = params.get('inspired_by');
      var inspInput = $('[data-inspired-by]', form);
      if (insp && inspInput) inspInput.value = insp;
      if (params.get('path') === 'own' || params.get('path') === 'source') setPath(params.get('path'));
    });
  }

  /* ---------- Archive filters ---------- */
  function initArchive() {
    $$('[data-archive-filters]').forEach(function (bar) {
      var grid = $('[data-archive-grid]');
      if (!grid) return;
      $$('[data-archive-filter]', bar).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-archive-filter');
          $$('[data-archive-filter]', bar).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          $$('li[data-tier]', grid).forEach(function (li) { li.classList.toggle('is-hidden', f !== 'all' && li.getAttribute('data-tier').split(' ').indexOf(f) === -1); });
        });
      });
    });
  }

  /* ---------- Auction live refresh (Section Rendering API, no reload) ---------- */
  function initAuctionRefresh() {
    $$('[data-auction][data-status="live"]').forEach(function (root) {
      var id = root.getAttribute('data-section-id');
      var every = (parseInt(root.getAttribute('data-refresh'), 10) || 20) * 1000;
      if (!id) return;
      function refresh() {
        if (document.hidden) return;
        fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-auction]', doc);
            if (!fresh) return;
            if (fresh.getAttribute('data-status') !== 'live') { window.location.reload(); return; }
            var oldBoard = $('.auction-board', root), newBoard = $('.auction-board', fresh);
            var sig = function (board) { return board ? $$('.auction-board__cell', board)[0].textContent.replace(/\s+/g, ' ').trim() : ''; };
            if (oldBoard && newBoard && sig(oldBoard) !== sig(newBoard)) {
              var newBid = $('[data-current-bid]', newBoard).textContent.trim();
              oldBoard.innerHTML = newBoard.innerHTML;
              initCountdown(oldBoard);
              oldBoard.classList.add('is-updated');
              setTimeout(function () { oldBoard.classList.remove('is-updated'); }, 2400);
              toast('New bid: ' + newBid);
            }
            var ni = $('[data-bid-input]', fresh), oi = $('[data-bid-input]', root);
            if (ni && oi) { oi.min = ni.min; oi.placeholder = ni.placeholder; }
            [['[data-min-label]', 'textContent'], ['[data-min-hidden]', 'value']].forEach(function (pair) {
              var n = $(pair[0], fresh), o = $(pair[0], root); if (n && o) o[pair[1]] = n[pair[1]];
            });
            var nh = $('.accordion', fresh), oh = $('.accordion', root);
            if (nh && oh && !oh.contains(document.activeElement)) {
              var openStates = $$('details', oh).map(function (d) { return d.open; });
              oh.innerHTML = nh.innerHTML;
              $$('details', oh).forEach(function (d, i) { if (openStates[i] !== undefined) d.open = openStates[i]; });
            }
          }).catch(function () {});
      }
      setInterval(refresh, every);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(ctx) {
    $$('[data-countdown]', ctx).forEach(function (el) {
      if (el._cd) return; el._cd = true;
      var raw = el.getAttribute('data-countdown').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      var target = new Date(raw).getTime();
      if (isNaN(target)) { el.hidden = true; return; }
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var wasRunning = target - Date.now() > 0;
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        $('[data-d]', el).textContent = pad(d); $('[data-h]', el).textContent = pad(h); $('[data-m]', el).textContent = pad(m); $('[data-s]', el).textContent = pad(s);
        if (diff <= 0) {
          clearInterval(timer);
          // Reload once when a timer finishes while the page is open, so status updates. Never loop.
          if (wasRunning) setTimeout(function () { window.location.reload(); }, 1500);
        }
      }
      var timer = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-recommendations]', tmp);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; bindForms(el); initReveal(); }
      }).catch(function () {});
    });
  }

  /* ---------- Shop page: collection rows / all pieces switch ---------- */
  function initShopViews(ctx) {
    $$('[data-shop-views]', ctx).forEach(function (box) {
      if (box._bound) return; box._bound = true;
      var btns = $$('[data-view-btn]', box), views = $$('[data-view]', box);
      function set(v, push) {
        views.forEach(function (el) { el.hidden = el.getAttribute('data-view') !== v; });
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view-btn') === v ? 'true' : 'false'); });
        if (push) { try { var u = new URL(window.location.href); if (v === box.getAttribute('data-start')) u.searchParams.delete('show'); else u.searchParams.set('show', v); history.replaceState(null, '', u.toString()); } catch (e) {} }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-view-btn'), true); }); });
      var q = new URLSearchParams(window.location.search).get('show');
      if (q === 'all' || q === 'rows') set(q, false);
    });
  }

  /* ---------- Lookbook: look viewer and one-at-a-time carousel ---------- */
  function initLookbook(ctx) {
    $$('[data-look-viewer]', ctx).forEach(function (viewer) {
      if (viewer._bound) return; viewer._bound = true;
      var section = viewer.parentNode, items = $$('[data-look-item]', section), stage = $('[data-look-stage]', viewer), at = 0, opener = null;
      if (!items.length) return;
      $$('body > [data-look-viewer]').forEach(function (old) { if (old.getAttribute('data-section') === viewer.getAttribute('data-section')) old.remove(); });
      document.body.appendChild(viewer);
      function show(i) {
        at = (i + items.length) % items.length;
        stage.innerHTML = '<div>' + items[at].innerHTML + '</div>';
        $$('img', stage).forEach(function (im) { im.loading = 'eager'; });
        bindForms(stage); stage.scrollTop = 0;
      }
      function open(i, btn) { opener = btn || null; show(i); viewer.hidden = false; document.body.classList.add('lb-open'); $('[data-look-close]', viewer).focus(); }
      function close() { viewer.hidden = true; stage.innerHTML = ''; document.body.classList.remove('lb-open'); if (opener) opener.focus(); }
      $$('[data-look-open]', section).forEach(function (btn) { btn.addEventListener('click', function () { open(parseInt(btn.getAttribute('data-look-open'), 10) || 0, btn); }); });
      $('[data-look-close]', viewer).addEventListener('click', close);
      $('[data-look-prev]', viewer).addEventListener('click', function () { show(at - 1); });
      $('[data-look-next]', viewer).addEventListener('click', function () { show(at + 1); });
      document.addEventListener('keydown', function (e) {
        if (viewer.hidden) return;
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') show(at - 1); else if (e.key === 'ArrowRight') show(at + 1);
      });
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 60) show(at + (dx < 0 ? 1 : -1)); });
    });
    $$('[data-lb-carousel]', ctx).forEach(function (car) {
      if (car._bound) return; car._bound = true;
      var track = $('[data-lb-track]', car), slides = $$('[data-lb-slide]', car), cur = $('[data-lb-current]', car), thumbs = $$('[data-lb-go]', car), at = 0;
      if (!slides.length) return;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(i); }
      function mark(i) { at = i; if (cur) cur.textContent = pad(i + 1); thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
      $('[data-lb-prev]', car).addEventListener('click', function () { go(at - 1); });
      $('[data-lb-next]', car).addEventListener('click', function () { go(at + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-lb-go'), 10)); }); });
      var tm; track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 80); }, { passive: true });
      track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1); } });
    });
  }

  /* ---------- Contact: some reasons go to their own page ---------- */
  function initContactRedirects() {
    $$('#ContactReason').forEach(function (sel) {
      var form = sel.closest('form'); if (!form || form._wiuRedirect) return; form._wiuRedirect = true;
      var fields = $('[data-contact-fields]', form), panels = $$('[data-contact-redirect]', form);
      if (!panels.length) return;
      var norm = function (v) { return String(v || '').trim().toLowerCase(); };
      function update() {
        var hit = null;
        panels.forEach(function (p) { var on = norm(p.getAttribute('data-contact-redirect')) === norm(sel.value); p.hidden = !on; if (on) hit = p; });
        if (fields) { fields.hidden = !!hit; $$('input,textarea,button', fields).forEach(function (el) { el.disabled = !!hit; }); }
      }
      sel.addEventListener('change', update); update();
    });
  }

  /* ---------- Contact prefill ---------- */
  function initContact() {
    initContactRedirects();
    var field = $('[data-prefill-piece]');
    if (!field) return;
    var piece = new URLSearchParams(window.location.search).get('piece');
    if (piece) {
      field.value = piece;
      var reason = $('#ContactReason');
      if (reason) $$('option', reason).forEach(function (o) { if (/piece/i.test(o.value)) reason.value = o.value; });
    }
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function () { initReveal(); initHero(); initAnnouncement(); initCountdown(document); bindForms(document); initProduct(); initChips(document); initCommission(); initLuxuryBudget(document); initNoRush(document); initInterestTags(document); initInstagram(document); initPlayers(document); initSmartForms(); initArchive(); initContactRedirects(); initLookbook(document); initShopViews(document); });
  document.addEventListener('shopify:block:select', function (e) {
    var dd = e.target.closest && e.target.closest('[data-dropdown]');
    if (dd) dd.classList.add('is-open');
  });

  function init() {
    initHeader(); initAnnouncement(); initHero(); initReveal();
    bindForms(document); bindCartItems(document);
    initArcade(); initProduct(); initCollection(); initArchive(); initChips(document); initCommission(); initLuxuryBudget(document); initNoRush(document); initInterestTags(document); initInstagram(document); initPlayers(document); initSmartForms(); initCountdown(document); initAuctionRefresh(); initRecommendations(); initContact(); initLookbook(document); initShopViews(document);
  }
  /* ---------- Form sent: pop-up confirmation ---------- */
  function initFormSuccess() {
    if (!/[?&](contact_posted|customer_posted)=true/.test(window.location.search)) return;
    var src = $$('.commission-success, .form-message').filter(function (el) { return !el.classList.contains('form-message--error'); })[0];
    var dlg = document.createElement('dialog');
    dlg.className = 'success-pop';
    dlg.setAttribute('aria-label', 'Sent');
    dlg.innerHTML = '<div class="success-pop__inner">' + (src ? src.innerHTML : '<p>Thank you. We received your message and will get back to you soon.</p>') +
      '<button type="button" class="btn btn--outline" data-success-close>Close</button></div>';
    document.body.appendChild(dlg);
    var close = function () { if (dlg.close) dlg.close(); dlg.remove(); };
    dlg.querySelector('[data-success-close]').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    if (src) src.scrollIntoView({ block: 'center' });
    if (window.history.replaceState) window.history.replaceState(null, '', window.location.pathname + window.location.hash);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFormSuccess); else initFormSuccess();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.WIU = { formatMoney: formatMoney, refreshCart: refreshDrawer, openDrawer: openDrawer };
})();
